"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _reactLazyLoad = _interopRequireDefault(require("react-lazy-load"));
var _Image = require("./Image.styles");
var _image = require("@qwkin/image");
var _imagePlaceholder = _interopRequireDefault(require("../../assets/images/imagePlaceholder.png"));
var _reactMediumImageZoom = _interopRequireDefault(require("react-medium-image-zoom"));
var _theme = require("../utils/theme");
var _excluded = ["children", "theme", "src", "zoomSrc", "animate", "shouldZoom"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Image = function Image(_ref) {
  var children = _ref.children,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    _ref$src = _ref.src,
    src = _ref$src === void 0 ? _imagePlaceholder["default"] : _ref$src,
    _ref$zoomSrc = _ref.zoomSrc,
    zoomSrc = _ref$zoomSrc === void 0 ? _imagePlaceholder["default"] : _ref$zoomSrc,
    _ref$animate = _ref.animate,
    animate = _ref$animate === void 0 ? true : _ref$animate,
    shouldZoom = _ref.shouldZoom,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (shouldZoom) {
    return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
      theme: theme
    }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoad["default"], null, /*#__PURE__*/_react["default"].createElement(_reactMediumImageZoom["default"], {
      shouldReplaceImage: false,
      image: _objectSpread({
        src: (0, _image.isBase64String)(src) ? "data:image/gif;base64,".concat(src) : src
      }, props),
      zoomImage: {
        src: (0, _image.isBase64String)(zoomSrc) ? "data:image/gif;base64,".concat(zoomSrc) : zoomSrc ? zoomSrc : src
      }
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoad["default"], null, animate ? /*#__PURE__*/_react["default"].createElement(_Image.PlainImage, (0, _extends2["default"])({
    src: (0, _image.isBase64String)(src) ? "data:image/gif;base64,".concat(src) : src
  }, props, {
    animate: animate
  })) : /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({
    src: (0, _image.isBase64String)(src) ? "data:image/gif;base64,".concat(src) : src
  }, props, {
    animate: animate
  }))));
};
var _default = exports["default"] = Image;